import { defaultTheme } from './themes/defaultTheme';
import { idStainMouthwashTheme } from './themes/idStainMouthwashTheme';
import { toothArmourTheme } from './themes/toothArmourTheme';
import { toothWipesTheme } from './themes/toothWipesTheme';
import type { region } from '@/composables/regionHelpers';

export type {
  CollectionBannerMedia,
  FreeGiftProduct,
  GlobalProductPill,
  HomeSaleBannerData,
  HomeShowcaseMode,
  ThemeData,
} from './models';

const themes = {
  defaultTheme,
  toothWipesTheme,
  idStainMouthwashTheme,
  toothArmourTheme,
};

type ThemeKey = keyof typeof themes;

const fallbackTheme: ThemeKey = 'idStainMouthwashTheme';

declare global {
  interface Window {
    global_theme?: string;
    global_legal_notice?: boolean | null;
    global_free_gift?: boolean | null;
  }
}

const requestedTheme = window.global_theme?.trim();

const currentTheme: ThemeKey =
  requestedTheme && requestedTheme in themes ? (requestedTheme as ThemeKey) : fallbackTheme;

const theme = themes[currentTheme];

export const {
  freeGiftProduct,
  collectionBanner,
  collectionBannerHideText,
  homeHero,
  homeHeroBanner,
  homeSaleBanner,
  homeShowcaseMode,
  homeShowcaseOptions,
  homeShowcaseContent,
  homeShowcaseMedia,
  homeShowcaseMediaLink,
  navImageBlocks,
  marqueeData,
  delayedShippingMessages,
  globalProductPill,
  globalProductCardBadge,
  globalProductImageBadge,
} = theme;

export const legalNotice: region<boolean> =
  window.global_legal_notice == null ? theme.legalNotice : { default: window.global_legal_notice };
